import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SelectKitNoneRow = dt7948.c(class SelectKitNoneRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#each this.icons as |i|}}\n      {{icon i translatedTitle=this.dasherizedTitle}}\n    {{/each}}\n\n    <span class=\"name\">\n      {{this.label}}\n    </span>\n  ", {
      strictMode: true,
      scope: () => ({
        icon
      })
    }), this);
  }
}, [classNames("none")]);
export default SelectKitNoneRow;